import React from "react"

// A device can report no touch support up front and still receive a touch event
// (hybrid laptops, some Android WebViews), so a real touch latches the value on.
let hasObservedTouch = false

const subscribe = (onStoreChange: () => void) => {
  const handleTouchStart = () => {
    hasObservedTouch = true
    onStoreChange()
  }

  window.addEventListener('touchstart', handleTouchStart, { once: true })
  return () => window.removeEventListener('touchstart', handleTouchStart)
}

const getSnapshot = () =>
  hasObservedTouch || 'ontouchstart' in window || navigator.maxTouchPoints > 0

export function useIsTouch() {
  return React.useSyncExternalStore(subscribe, getSnapshot, () => false)
}
